export default {
    'Internal media storage is empty.': 'El almacenamiento interno de medios está vacío.',
}